<template>
  <div class="body-box">
    <div class="contents navigation-contents">
      <p class="navigation">
        <i class="icon iconfont icon-yuanquan_huaban1"></i>
        <span class="nowshow">当前位置：</span>

        <router-link class="navigation-now" tag="a" :to="{ name: 'index' }"
          >首页</router-link
        >
        <i class="icon iconfont icon-youjiantou"></i>
        <router-link
          class="navigation-now"
          tag="a"
          :to="{ name: 'classIndex', params: { id: 1 } }"
          >产品</router-link
        >
        <i class="icon iconfont icon-youjiantou"></i>
        <span class="navigation-now">产品详情</span>
      </p>
    </div>
    <goods-info
      :area="goodsHeaders.area"
      :bannerImg="goodsHeaders.image"
      :bannerId="goodsHeaders.id"
      :className="goodsHeaders.className"
      :collection="goodsHeaders.collection"
      :goodsInfo="goodsIntroduction"
      @toshoucang="toshoucang"
      ref="goodsInfo"
    ></goods-info>
    <div class="contents contents-goods">
      <!--产品切换图-->
      <goods-swiper v-if="showSwiper == 1" ref="gswiper"></goods-swiper>
      <div class="contents-goods-right">
        <div class="contents-goods-right-title">
          <p>{{ goodsIntroduction.title }}</p>
        </div>
        <div
          class="contents-goods-right-tag"
          v-if="
            goodsIntroduction.char_tag &&
              goodsIntroduction.char_tag.length > 0 &&
              goodsIntroduction.char_tag[0]
          "
        >
          <span
            v-for="(tag, index) in goodsIntroduction.char_tag"
            :key="index"
            class="contents-goods-right-tag-span"
          >
            {{ tag }}
          </span>
        </div>
        <!-- <div class="contents-goods-right-attr" v-for="Middle in goodsIntroduction.productMiddle" v-if="Middle.info!=''" >
                    <div class="contents-goods-right-attr-left">
                        {{Middle.title}}：
                    </div>
                    <div class="contents-goods-right-attr-right">
                         {{Middle.info}}
                    </div>
                </div> -->
        <!--新的产品描述和产品特点-->
        <div
          class="contents-goods-right-info info-type1"
          v-for="(productInfo, pindex) in goodsIntroduction.productInfo"
          v-if="
            productInfo.info.length > 0 &&
              productInfo.info[0] != '' &&
              productInfo.type == 1
          "
        >
          <div class="type1-left">
            <img v-if="pindex == 0" src="/static/icon/jieshao.png" />
            <img v-if="pindex == 1" src="/static/icon/tedian.png" />
          </div>
          <div class="type1-right">
            <div class="type1-right-title">{{ productInfo.title }}</div>
            <div class="type1-right-info">
              <p v-for="item in productInfo.info">
                {{ item }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="contents-goods-right-info"
          v-for="(productInfo, pindex) in goodsIntroduction.productInfo"
          v-if="
            productInfo.info.length > 0 &&
              productInfo.info[0] != '' &&
              productInfo.type == 2
          "
        >
          <div
            class="
              contents-goods-right-info-left
              contents-goods-right-info-right-block-title
            "
          >
            同系列型号
          </div>
          <div
            class="
              contents-goods-right-info-right
              contents-goods-right-info-right-block-span
            "
          >
            <span v-for="(mInfi, mindex) in productInfo.info"
              >【{{ mInfi }}】</span
            >
          </div>
        </div>

        <!-- <div class="contents-goods-right-info">
                    <div class="contents-goods-right-info-left">
                        资质认证：
                    </div>
                    <div class="contents-goods-right-info-right contents-goods-right-info-right-block-span">
                        <span class="contents-goods-right-info-right-span"  >撒旦发顺丰</span>
                    </div>

                </div> -->
        <div class="contents-goods-right-info">
          <div
            class="
              contents-goods-right-info-left
              contents-goods-right-info-left-price
            "
          >
            <!-- 参考价 -->
          </div>
          <div
            class="
              contents-goods-right-info-right contents-goods-right-info-price
            "
          >
            <!-- <i class="icon iconfont icon-renminbi1688"></i
            ><span class="contents-goods-right-info-right-price">{{
              goodsIntroduction.price
            }}</span> -->
            <span class="contact-us">
              <router-link :to="{ name: 'helpcooperationgoods' }"
                >联系我们</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="contents goods-tabs">
      <ul class="goods-tabs-header" :class="{ goodsTH: goodsInfo.length == 4 }">
        <div v-for="(goods, index) in goodsInfo" :key="index">
          <li
            :class="{ active: index == activeIndex }"
            @click="goodsCheck(index)"
          >
            {{ goods.title == "下载产品手册" ? "下载资料" : goods.title }}
          </li>
        </div>
      </ul>
      <div class="goods-tabs-body">
        <div v-for="(goods, indexw) in goodsInfo">
          <div
            class="goods-tabs-body-item"
            v-if="goods.type == 1"
            v-show="indexw == activeIndex"
          >
            <div v-if="indexw > 0">
              <img v-lazy="goods.imgurl" />
              <div
                class="contents"
                v-if="
                  goodsIntroduction.contentTxt2 &&
                    goodsIntroduction.contentTxt2 != ''
                "
              >
                <div class="contents-table">
                  <p
                    class="v-html-jiegou"
                    v-html="goodsIntroduction.contentTxt2"
                  ></p>
                </div>
              </div>
            </div>

            <div v-else class="contents">
              <div class="contents-table">
                <!--产品系列切换图-->
                <template v-if="goods.name && goods.name[0]">
                  <div ref="mVhtml" class="m-vhtml"><h1>同系列产品</h1></div>
                  <goods-series-swiper
                    :goodsList="goods"
                    v-if="showSwiper == 1"
                  ></goods-series-swiper>
                </template>
                <p
                  v-if="goodsIntroduction.txtype == 1"
                  class="m-vhtmls mm-vhtml"
                  v-html="arrange(goodsIntroduction.contentTxt)"
                ></p>
                <p
                  v-else
                  class="m-vhtml mm-vhtml"
                  v-html="goodsIntroduction.contentTxt"
                ></p>
              </div>
            </div>
          </div>
          <goods-product
            :goods="goods"
            v-if="goods.type == 2"
            v-show="indexw == activeIndex"
          ></goods-product>
          <goods-down
            :goods="goods"
            v-if="goods.type == 3 && showSwiper == 1"
            v-show="indexw == activeIndex"
            :classId="goodsIntroduction.class_info.id"
            :goodsId="goodsid"
          ></goods-down>
        </div>
      </div>
    </div>
    <comparison />
  </div>
</template>

<script>
import GoodsInfo from "../../components/goods/GoodsInfo.vue";
import GoodsSwiper from "../../components/goods/GoodsSwiper.vue";
import GoodsProduct from "../../components/goods/GoodsProduct.vue";
import GoodsDown from "../../components/goods/GoodsDown.vue";
import Comparison from "../../components/goods/Comparison.vue";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import GoodsSeriesSwiper from "../../components/goods/GoodsSeriesSwiper.vue";
export default {
  data() {
    return {
      goodsInfo: "",
      goodsHeaders: "",
      goodsIntroduction: "",
      activeIndex: 0,
      goodsid: 0,
      showSwiper: 1
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  },
  components: {
    GoodsInfo,
    GoodsSwiper,
    GoodsProduct,
    GoodsDown,
    GoodsSeriesSwiper,
    Comparison
  },

  methods: {
    open(url, title) {
      this.$alert("<img width='100%' src=" + url + "/>", title, {
        dangerouslyUseHTMLString: true
      });
    },
    goodsCheck(index) {
      this.activeIndex = index;
    },
    savetemp(bannerimg, imgurl, goodsid) {
      localStorage.setItem("bannerimg", bannerimg);
      localStorage.setItem("imgurl", imgurl);
      localStorage.setItem("goodsid", goodsid);
    },
    getinfo(goodsid) {
      var info = {};
      info.id = goodsid;
      info.uid = this.UserId;
      this.$api.goods.getgoodinfo(info).then(res => {
        this.goodsHeaders = res.data.datas.brand_info;
        this.goodsHeaders.area =
          this.goodsHeaders.country + "•" + this.goodsHeaders.city;
        this.goodsHeaders.className = res.data.datas.class_info.name;

        this.$refs.goodsInfo.getBrandInfoAll(this.goodsHeaders.id);
        //保存产品图片， 品牌图片，商品id  todo
        this.savetemp(
          res.data.datas.brand_info.image,
          res.data.datas.avatar,
          this.goodsid
        );

        //切换图
        this.$refs.gswiper.getgoodsSwiper(res.data.datas.pics);

        //基本信息
        this.goodsIntroduction = res.data.datas;
        //详细信息
        this.goodsInfo = res.data.datas.pic_cs;
      });
    },
    toshoucang() {
      this.$api.goods
        .getStoreAdd(this.goodsid, (this.goodsIntroduction.store + 1) % 2)
        .then(res => {
          if (res.data.errno == 0) {
            if (this.goodsIntroduction.store == 1) {
              this.$FUnitls.showInfo("取消收藏", "info");
              this.$set(this.goodsIntroduction, "store", 0);
            } else {
              this.$FUnitls.showInfo("已收藏", "info");
              this.$set(this.goodsIntroduction, "store", 1);
            }
          } else {
            var options = {
              message: res.data.errmsg
            };
            Message.error(options);
          }
        });
    },
    arrange(ceshihtml) {
      return ceshihtml.replace("table", 'table class="mtable"');
    }
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.goodsid = this.$route.params.goodsid;
      this.showSwiper = 2;
      this.getinfo(this.goodsid);
      this.$nextTick(function() {
        this.showSwiper = 1;
      });
    }
  },
  mounted() {
    this.goodsid = this.$route.params.goodsid;
    this.getinfo(this.goodsid);
    this.$nextTick(() => {
      $(this.$el).on("click", ".mm-vhtml h4 img", () => {
        this.activeIndex = this.goodsInfo.length - 1;
        window.scrollTo(0, 500);
      });
    });
  },
  computed: {
    ...mapGetters(["UserId"])
  }
};
</script>
<style scoped>
.body-box {
  background-color: #f3f5f7;
  /* overflow: hidden; */
}
.contents-goods-right-info-right-price {
  font-size: 30px;
  color: #ff1111;
}
.contents-goods-right-info-price .icon {
  color: #ff1111;
}
.contents-goods-right-info-price .contact-us {
  overflow: hidden;
}
.contents-goods-right-info-price {
  padding-right: 50px;
}
.contents-goods-right-info-right-block-span {
  width: 100px;
}
.contents-goods-right-info-right-block-span span {
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
  margin-right: 10px;
  /* margin-bottom: 5px; */
}
.contents-goods-right-info-price .contact-us a {
  float: right;
  color: #fff;
  background-color: #2655ae;
  padding: 2px 20px;
  border-radius: 20px;
}
.contents-goods-right-info-price .contact-us a:hover {
  background-color: rgba(38, 85, 174, 0.9);
}

.contents-goods-right {
  width: 650px;
}
.contents-goods-right .contents-goods-right-title {
  color: #232323;
  font-size: 24px;
  border-bottom: 1px solid #e0e1e2;
  width: 90%;
  margin-bottom: 10px;
}
.contents-goods-right .contents-goods-right-title p {
  position: relative;
  padding-left: 18px;
}
.contents-goods-right-title p::before {
  position: absolute;
  content: " ";
  left: 0;
  top: 6px;
  background-color: #2655ae;
  width: 3px;
  height: 21px;
}
.contents-goods {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
  margin-bottom: 40px;
}
.contents-goods-right-title p {
  margin-bottom: 10px;
}
.contents-goods-right-attr {
  display: flex;
  font-size: 18px;
  color: #333333;
  /* font-weight: 550; */
  height: 35px;
  line-height: 35px;
}
.contents-goods-right-attr .contents-goods-right-attr-left {
  color: #666;
}
/* .contents-goods-right-attr .contents-goods-right-attr-right{
        color: #666;
    } */
.contents-goods-right-info {
  display: flex;
  font-size: 16px;
  margin-bottom: 10px;
  color: #666666;
}
.contents-goods-right-info .contents-goods-right-info-left {
  width: 80px;
  height: 35px;
  line-height: 35px;
}

.contents-goods-right-info .contents-goods-right-info-left-price {
  width: 70px;
}
.contents-goods-right-info-left-price {
  font-size: 18px;
}
.contents-goods-right-info .contents-goods-right-info-right {
  width: 570px;
  line-height: 35px;
  font-size: 14px;
  color: #333333;
}
.contents-goods-right-info-right-span {
  background-color: #fbb113;
  color: #fff;
  line-height: 27px;
  padding: 5px 20px;
  border-radius: 20px;
}

/**详细信息 */
.goods-tabs ul {
  width: 100%;
  overflow: hidden;
}
.goods-tabs .goods-tabs-header li {
  width: 20%;
  float: left;
  padding: 10px 0;
  text-align: center;
  background-color: #e0e6ec;
  cursor: pointer;
}
.goods-tabs .goodsTH li {
  width: 25%;
}
.goods-tabs ul .active {
  background-color: #2655ae;
  color: #fff;
}
.goods-tabs-body {
  background-color: #fff;
}
.goods-tabs-body-item img {
  width: 100%;
}

/**导航 */
.navigation .icon-yuanquan_huaban1 {
  color: #fbb113;
}
.navigation {
  margin-top: 25px;
  float: right;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.navigation-contents {
  overflow: hidden;
}
.nowshow {
  color: #666;
}
.navigation-now {
  color: #888;
}
.navigation a:hover {
  color: #2655ae;
  text-decoration: underline;
}

.contents-goods-right-tag .contents-goods-right-tag-span {
  padding: 6px 25px;
  display: inline-block;
  border: 1px solid #2655ae;
  border-radius: 16px;
  color: #2655ae;
  background-color: #d8e5ff;
  margin-right: 26px;
  margin-bottom: 10px;
}
.contents-goods-right-tag {
  margin-top: 22px;
  overflow: hidden;
  margin-bottom: 6px;
}
.type1-left {
  width: 24px;
  height: 24px;
}
.type1-left img {
  width: 100%;
}
.type1-right {
  width: 614px;
}
.info-type1 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.type1-right-title {
  line-height: 24px;
  font-size: 16px;
  color: #666666;
}
.type1-right-info {
  margin-top: 10px;
}
.type1-right-info p {
  font-size: 14px;
  line-height: 2;
  color: #333333;
  letter-spacing: 1px;
}
.contents-goods-right-info .contents-goods-right-info-right-block-title {
  width: 86px;
}
.contents-goods-right-info .contents-goods-right-info-right-block-span {
  width: 550px;
  color: #2655ae;
}
/**富文本样式 */
/**表格样式 */

.v-html-jiegou >>> table {
  width: 100% !important;
  text-align: center;
  border: 1px solid #dfe6f3;
}
.v-html-jiegou >>> table tr:first-child,
.v-html-jiegou >>> table tr:nth-child(2) {
  background-color: #2655ad !important;
  color: #fff !important;
}
.v-html-jiegou >>> table tr td {
  width: auto !important;
  text-align: center;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding: 10px 0;
}
.v-html-jiegou >>> table tr:last-child td {
  border-bottom: 1px solid #dfe6f3;
}
.v-html-jiegou >>> table tr td:last-child {
  border-right: 1px solid #dfe6f3;
}
.v-html-jiegou >>> table tr:nth-child(2n-1) {
  background-color: rgba(69, 124, 226, 0.15);
  color: #333333;
}

.m-vhtmls >>> table {
  width: 100% !important;
  table-layout: fixed;
  word-break: break-all;
  word-wrap: break-word;
  box-sizing: border-box;
  border: 1px solid #dfe6f3;
}
.m-vhtmls >>> table tr:last-child td {
  border-bottom: 1px solid #dfe6f3;
}
.m-vhtmls >>> table tr td:last-child {
  border-right: 1px solid #dfe6f3;
}
.m-vhtmls >>> table tr:first-child {
  background-color: #2655ad !important;
  color: #fff !important;
}
.m-vhtmls >>> table tr td {
  width: auto !important;
  text-align: center;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding: 10px 0;
}
.m-vhtmls >>> table tr:nth-child(2) {
  background: #dfe6f3;
}

.m-vhtmls >>> .mtable tr td {
  padding: 6px 0;
}
.m-vhtmls >>> .mtable tr:first-child {
  background-color: #2655ad !important;
  color: #fff !important;
  height: 100px;
}
.m-vhtmls >>> .mtable tr:first-child td {
  color: #fff !important;
}
.m-vhtmls >>> .mtable tr:nth-child(2) {
  background-color: #2655ad;
}
.m-vhtmls >>> .mtable tr:nth-child(2) td {
  color: #fff !important;
}

.m-vhtmls >>> .mtable tr:nth-child(2n-1) {
  background-color: rgba(69, 124, 226, 0.15);
  color: #333333;
}

.m-vhtml,
.m-vhtmls {
  overflow: hidden;
}
.m-vhtml >>> table {
  width: 100% !important;
  border: none;
  background-color: #fff;
}
.m-vhtml >>> table tr:first-child {
  color: #fff;
}
.m-vhtml >>> table tr {
  /* display: flex; */
}
.m-vhtml >>> table tr td:first-child {
  background: #2655ad;
  border-bottom: 1px solid #fff;
  color: #ffffff;
}
.m-vhtml >>> table td,
.m-vhtml >>> table th {
  font-size: 14px;
  color: #333333;
  text-align: left;
  padding: 10px 20px;
  font-weight: 500;
}
.m-vhtml >>> h4 {
  cursor: pointer;
}

.m-vhtml >>> table tr th:first-child,
.m-vhtml >>> table tr td:first-child {
  /* border-right: 15px solid #fff; */
  width: 331px;
}
.m-vhtml >>> table tr th:last-child,
.m-vhtml >>> table tr td:last-child {
  /* border-left: 15px solid #fff; */
  width: 779px;
}

.m-vhtml >>> tr:nth-child(2n + 1) {
  background-color: rgba(69, 124, 226, 0.15);
}
.m-vhtml >>> h1,
.m-vhtml h1,
.m-vhtmls >>> h1,
.m-vhtmls h1 {
  font-size: 20px;
  color: #333;
  position: relative;
  padding-left: 15px;
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 20px;
}
.m-vhtml >>> h1::before,
.m-vhtml h1::before,
.m-vhtmls >>> h1::before,
.m-vhtmls h1::before {
  position: absolute;
  content: " ";
  width: 3px;
  height: 80%;
  left: 0;
  top: 10%;
  background-color: #2655ae;
}
.m-vhtml >>> h2,
.m-vhtml h2,
.m-vhtmls >>> h2,
.m-vhtmls h2 {
  font-size: 18px;
  color: #2655ae;
  margin-top: 15px;
  margin-bottom: 30px;
}
.contents-table {
  width: 1140px;
  margin: 0 auto;
}

/**符文本显示结束 */

/* blockquote 样式 */
blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}
/* code 样式 */
code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
pre code {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/info.vue